import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { I18n } from '@aws-amplify/core';
import { Spin } from 'antd';

import { SelectCompany } from './SelectCompany';
import { useGetCompanies } from '../../../hooks/index';
import { useContractPlansContext } from '../../../context';

export function ManageCompany() {
	const { queryUrl } = useContractPlansContext();

	const {
		data: companies,
		isError: errorGettingCompanies,
		isLoading: gettingCompanies,
		isFetching: fetchingCompanies,
		refetch: companyRefetch
	} = useGetCompanies(queryUrl && queryUrl.get('organization_id'));

	if (errorGettingCompanies) {
		return I18n.get('Oops... Something went wrong!');
	}

	if (fetchingCompanies || gettingCompanies) {
		const antIcon = <LoadingOutlined style={{ fontSize: 50, marginBottom: '120px' }} spin />;
		return <Spin indicator={antIcon} />;
	}

	return <SelectCompany companies={companies} companyRefetch={companyRefetch} />;
}
